import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormEnums } from "models/enums";
import { TimeReportingProjectFormTypes } from "models/formTypes";
import { FormHandles, GenericFormSection } from "models/propTypes/genericFormProps";
import { TimeReportingProjectCategoryFormViewProps } from "models/propTypes/timeReportingProjectPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
import useCategoryGeneralFields from "./useCategoryGeneralFields";
import useCategoryMemberRatesFields from "./useCategoryMemberRatesFields";
//#endregion

const TimeReportingProjectCategoryForm: ForwardRefRenderFunction<
  FormHandles,
  TimeReportingProjectCategoryFormViewProps
> = (props, ref) => {
  const projectCategoryGeneralFields = useCategoryGeneralFields(props);
  const projectCategoryMemberFields = useCategoryMemberRatesFields(props);

  const formFieldsStep1: GenericFormSection<TimeReportingProjectFormTypes.ProjectCategory>[] = [
    {
      label: TranslationKeys.TimeReportingProject.General,
      type: FormEnums.FormSectionType.SIMPLETAB,
      innerFields: projectCategoryGeneralFields,
    },
  ];

  const formFieldsStep2: GenericFormSection<TimeReportingProjectFormTypes.ProjectCategory>[] = [
    {
      label: TranslationKeys.TimeReportingProject.Rates,
      type: FormEnums.FormSectionType.SIMPLETAB,
      innerFields: projectCategoryMemberFields,
      hidden: (values: TimeReportingProjectFormTypes.ProjectCategory) =>
        !values.categoryMembers?.some((cm) => cm.selected) && (values.futureMemberRates?.length ?? 0) === 0,
    },
  ];
  return (
    <GenericForm
      formRef={ref}
      {...props}
      fields={formFieldsStep1.concat(formFieldsStep2)}
      hideSuccess
      enableControlLables
      formGridLayout={{ message: false }}
    />
  );
};

export default forwardRef(TimeReportingProjectCategoryForm);
